/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { generalEnvVars } from './env-vars'

export const urlBase = generalEnvVars.baseUrl
export const apiUriBase = generalEnvVars.apiUri
export const apiUrlBase = generalEnvVars.apiUri
export const publicBucketBaseUrl = process.env.BASE_URL_BUCKET_ASSET_FILES
export const filesThumbnailsBaseUrl = `${publicBucketBaseUrl}/defaults/file-type-thumbnails`
export const defaultThumbnailUrl = `${filesThumbnailsBaseUrl}/default-thumbnail.png`
export const filesTypeIconsBaseUrl = `${publicBucketBaseUrl}/defaults/file-type-icons`

export const urlsUser = {
  account: 'account',
  login: 'login',
  logout: 'logout'
}

export const embeddingsUrls = {
  base: 'embeddings',
  embedding: ':embeddingId',
  allLicenseHistory: ':embeddingId/all-license-history'
}

export const manageLlmAccessUrls = {
  base: 'manage-llm-access',
  details: ':tagId'
}

export const licensedAssetsUrls = {
  base: 'licensed-assets',
  licensedAsset: ':licensedAssetId',
  allLicenseHistory: ':licensedAssetId/all-license-history'
}

export const assetLicenseBatchesUrls = {
  base: 'asset-license-batches',
  create: 'create',
  batch: ':batchId'
}

export const assetLicensesUrls = {
  base: 'asset-licenses'
}

export const generateAIMetadataUrls = {
  base: 'generate-ai-metadata',
  register: 'register',
  batch: ':batchId'
}

export const aiMetadataBatchesUrls = {
  base: 'ai-metadata-batches',
  create: 'create',
  buildId: ':batchId'
}

export const generalUrls = {
  account: 'account',
  agreement: 'agreement',
  assetLicensed: licensedAssetsUrls.base,
  assetListings: assetLicensesUrls.base,
  base: '/',
  aiMetadataBatches: aiMetadataBatchesUrls.base,
  embeddings: embeddingsUrls.base,
  generateAIMetadata: generateAIMetadataUrls.base,
  assetLicenseBatches: assetLicenseBatchesUrls.base,
  licensed: licensedAssetsUrls.base,
  llmAccess: manageLlmAccessUrls.base,
  login: 'login',
  logout: 'logout',
  offers: 'offers'
}

export const thumbnailUrlsByFileType = {
  audio: `${filesThumbnailsBaseUrl}/default-audio.png`,
  video: `${filesThumbnailsBaseUrl}/default-video.png`,
  image: `${filesThumbnailsBaseUrl}/default-image.png`,
  document: `${filesThumbnailsBaseUrl}/default-thumbnail.png`,
  unknown: `${filesThumbnailsBaseUrl}/default-unknown.png`
}

export const iconUrlsByFileType = {
  audio: `${filesTypeIconsBaseUrl}/default-audio-icon.png`,
  video: `${filesTypeIconsBaseUrl}/default-video-icon.png`,
  image: `${filesTypeIconsBaseUrl}/default-image-icon.png`,
  document: `${filesTypeIconsBaseUrl}/default-document-icon.png`,
  unknown: `${filesTypeIconsBaseUrl}/default-unknown-icon.png`
}
